import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { makePhotoObject } from '../../libs/helpers'
import Loading from '../../components/layouts/Loading'
import { Container, Row } from 'react-bootstrap';
import PageHeader from '../../components/pageHeader/pageHeader.component';
import PhotoGallery from '../../components/photoGallery/photoGallery.component';
import PhotoGalleryPageCover from '../../assets/images/banners/Photo-album.png';


const PhotoAlbumPage = props => {

    const { albumId } = useParams()
    const { loading, photoAlbums } = useSelector(state => state.all)

    const [album, setAlbum] = useState()

    useEffect(() => {
        setAlbum(photoAlbums.find(item => item._id === albumId))
    }, [photoAlbums, albumId])

    return (

        album ? <div>
            <PageHeader
                title={album.name}
                cover={PhotoGalleryPageCover}
            >
                <p>
                    {album.description}
                </p>
            </PageHeader>
            <section className="photo-album-section py-5 border-top border-bottom bg-light">
                <Container >
                    <Row className="mb-5">
                        <PhotoGallery photos={makePhotoObject(album.pictures)} />
                    </Row>
                </Container>
            </section>
        </div> : <Loading />

    )
}

export default PhotoAlbumPage;